  <template
              
            >
             <vs-table
              :sst="true"
              @search="handleSearch"
              @selected="handleSelected"
              v-model="selected"
              :total="totalItems"
              max-items="10"
              search
              :data="subindustries">

              <div v-bar class="vs-scrollable" style="line-height: 2.45; display: flex;">
                <div>
                  <div class="con-exemple-customer-prompt px-4 py-3">
                      <vs-row>
                      <b>{{$t('Service.Table.Id')}}</b> : {{selected.id}}
                    </vs-row>
                    <vs-row>
                      <b>{{$t('Service.Table.Title')}} </b>: {{selected.title}}
                    </vs-row>
                     


                    <vs-row>
                      <b>{{$t('Service.Table.Industry')}} </b>: {{selected.industry_id}}
                    </vs-row>

                    <vs-row>
                      <h3><br> Translations </h3>
                    </vs-row>
                    <div v-if="selected.translations">
                    <vs-row>
                      <b>en</b> : {{selected.translations.en}}
                    </vs-row>
                    <vs-row>
                      <b>fr</b> : {{selected.translations.fr}}
                    </vs-row>
                    <vs-row>
                      <b>ar</b> : {{selected.translations.ar}}
                    </vs-row>

                    <vs-row>
                      <vs-col vs-w="12" class="text-right mt-4">
                        <vs-button @click="deletee()" color="danger" class="pr-5 pl-5 float-left"> {{$t('Booking.EditPrompt.DeleteButton')}} </vs-button>
                      </vs-col>
                    </vs-row>
                    </div>


                    <vs-pagination
              @change="handleChangePage"
              :total="totalPages"
              v-model="currentPage"
            ></vs-pagination>
                  </div>
                </div>
              </div>
            </vs-table>

</template>

<script>
import { subindustryServices } from '../../_services'
import router from "../../_helpers/router";

export default {
    name:"ViewService",
    data: () => ({
    title: "",
    lname: "",
    phone_number: "",
    address: "",
    email: "",
    notes: "",
    internalId: "",
    totalPages: 0,
        currentPage: 1,
        subindustry: [],

    }),
    props:{
        selected : Object
    },
    mounted(){


    },
    methods: {
      deletee() {
        subindustryServices.deletee(this.selected.id).then(function(data){
          location.reload();
          console.log('deleted')
        });
      }
    },

    handleChangePage(page) {
            this.showLoading();
            subindustryServices.getPage(page).then(function (data) {
                this.subindustry = data.subindustries.data;
            }.bind(this)).finally(() => {
                this.hideLoading();
            });
        },
}
</script>
